import { jsx as _jsx } from "react/jsx-runtime";
import { cleanOrderGroup, DBDef_OrderGroup } from '@app/pathway-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_OrderGroup } from '../../../_entity.js';
import { Editor_OrderGroup } from '../../Editor_OrderGroup/Editor_OrderGroup.js';
import './Manager_OrderGroup.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_OrderGroup_Wrapper = (props) => _jsx(LL_V_L, { className: 'manager-order-group', children: _jsx(Editor_OrderGroup, { editable: props.editable }) });
export const Manager_OrderGroup = createWorkHubManager({
    module: ModuleFE_OrderGroup,
    dbDef: DBDef_OrderGroup,
    defaultItem: cleanOrderGroup,
    labelResolver: (item) => item.name ?? 'New Order Group',
    EditorComponent: Editor_OrderGroup_Wrapper,
});
//# sourceMappingURL=Manager_OrderGroup.js.map